/* app/js/src/components/uploads-report/uploads-report.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: 13px 22px 15px 32px;
  width: 100%;
  overflow: hidden;
}
.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-text {
  color: #232f3a;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
}
.back-to-scheduler-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.table-header {
  display: flex;
  margin-top: 36px;
  margin-bottom: 10px;
}
.table-header input:focus {
  outline: none !important;
}
.table-header input::placeholder {
  color: #c9cdd6;
  font-family: "Open Sans";
  font-size: 12px;
}
.search-input {
  cursor: pointer;
  height: 30px;
  width: 174px;
  background-color: #f1f3f4;
  background-image: url(/assets/icons/search.svg);
  background-repeat: no-repeat;
  background-position: 6px 6px;
  -webkit-appearance: none;
  border: none;
  border-radius: 4px;
  padding-left: 35px;
  line-height: 36px;
  margin-right: 26px;
  color: #c9cdd6;
  font-family: "Open Sans";
  font-size: 12px;
}
.last-refresh {
  margin-right: 20px;
  line-height: 30px;
  color: #879baf;
  font-family: "Open Sans";
  font-size: 12px;
}
.refresh {
  height: 30px;
  width: 30px;
  border-radius: 3px;
  background-color: #f1f3f4;
  padding-top: 9px;
  text-align: center;
  cursor: pointer;
}
.status-cell {
  display: flex;
  align-items: center;
  text-align: center;
}
.status-cell i {
  margin-right: 8px;
}
.quality {
  font-family: "Open Sans";
  font-size: 11px;
  font-weight: 600;
  text-align: center;
  border-radius: 25px;
  width: 100px;
  height: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 14px 0;
}
.quality-low {
  color: #ef5350;
  background-color: #f7dbdb;
}
.quality-medium {
  color: #ce8306;
  background-color: #f9f0cf;
}
.quality-high {
  color: #61b965;
  background-color: #deeedf;
}
ngx-datatable {
  flex-grow: 1;
}
.view-qc-button {
  width: 80px;
  height: 24px;
  border-radius: 3px;
  background-color: white;
  cursor: pointer;
  color: #232f3a;
  font-family: "Open Sans";
  font-size: 13px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
evrideo-copy-button {
  display: inline-block;
}
/*# sourceMappingURL=uploads-report.component.css.map */
